export default function customImageLoader({
  src,
  width,
  quality,
}: {
  src: string;
  width: number;
  quality?: number;
}) {
  const funcUrls = [
    "https://gandpconstruction.com/storage",
    "https://fn.gandpconstruction.com/storage",
    "https://media.gandpconstruction.com/storage",
    "http://localhost:7071/storage",
    "http://localhost:7072/storage"
  ];
  if (funcUrls.some(url => src.startsWith(url))) {
    return `${src}?width=${width}`;
  } else {
    return `${src}?width=${width}&quality=${quality || 75}`;
  }
}